import { ZUid } from "src/types/zUid";
import { EdDelayedNotifyDict } from "../../Obj2Tab/DelayedNotify/EdDelayedNotify";
import {
  loadDelayedNotify,
  saveDelayedNotify,
} from "../../Obj2Tab/DelayedNotify/apiDelayedNotify";
import { EdNotifyTemplateDict } from "../../Obj2Tab/NotifyTemplates/EdNotifyTemplate";
import {
  loadNotifyTemplates,
  saveNotifyTemplates,
} from "../../Obj2Tab/NotifyTemplates/apiNotifyTemplates";

/**
 * Частичное сохранение карт уведомлений.
 *
 * Из-за бага Ant Design во вложенности Collapse -> Tabs -> FormList часть
 * значений формы может потеряться, и в карте вместо содержимого окажется
 * undefined. Это отличается от случая, когда пользователь удалил все шаблоны:
 * тогда придёт пустой список. Поэтому сохраняется не карта целиком, а те ключи,
 * по которым содержимое пришло.
 */
const patched = <T>(oldMap: Record<string, T>, newMap: Record<string, T>) => {
  const result = { ...oldMap };
  Object.entries(newMap).forEach(([key, content]) => {
    if (content) result[key] = content;
  });
  return result;
};

export const patchNotifyTemplates = async (
  objectId: ZUid,
  newMap: EdNotifyTemplateDict,
) => {
  const oldMap = await loadNotifyTemplates(objectId);
  await saveNotifyTemplates(objectId, patched(oldMap, newMap));
};

export const patchDelayedNotify = async (
  objectId: ZUid,
  newMap: EdDelayedNotifyDict,
) => {
  const oldMap = await loadDelayedNotify(objectId);
  await saveDelayedNotify(objectId, patched(oldMap, newMap));
};
